<template>
    <div>
        <div class="row">
            <div class="row">
                <div class="col-md-4">
                    <h2>{{ getTranslation('lbl_client_create_headline') }} </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <form @submit.prevent="addClient">
                        <div class="form-group">
                            <label for="clientName">{{ getTranslation('lbl_client_name') }} *</label>
                            <input
                                    type="text"
                                    id="clientName"
                                    class="form-control"
                                    formControlName="clientName"
                                    v-model="client.clientName">
                        </div>
                        <div class="form-group">
                            <label for="clientName">{{ getTranslation('lbl_user_first_name') }} *</label>
                            <input
                                    type="text"
                                    id="firstName"
                                    class="form-control"
                                    formControlName="firstName"
                                    v-model="user.firstName">
                        </div>
                        <div class="form-group">
                            <label for="clientName">{{ getTranslation('lbl_user_last_name') }}</label>
                            <input
                                    type="text"
                                    id="lastName"
                                    class="form-control"
                                    formControlName="lastName"
                                    v-model="user.lastName">
                        </div>
                        <div class="form-group">
                            <label for="email">{{ getTranslation('lbl_user_mail') }} *</label>
                            <input
                                    type="email"
                                    id="email"
                                    class="form-control"
                                    formControlName="email"
                                    v-model="user.email"
                            >
                        </div>
                        <div class="form-group">
                            <label for="username">{{getTranslation('lbl_client_username') }} *</label>
                            <input
                                    type="text"
                                    id="username"
                                    class="form-control"
                                    formControlName="username"
                                    v-model="client.username">
                        </div>
                        <div class="form-group">
                            <label for="password">{{ getTranslation('lbl_password') }} *</label>
                            <input
                                    type="password"
                                    id="password"
                                    class="form-control"
                                    formControlName="password"
                                    v-model="password"
                                    >
                        </div>
                        <div class="form-group">
                            <label for="repeat-password">{{getTranslation('lbl_repeat_password') }} *</label>
                            <input
                                    type="password"
                                    id="repeat-password"
                                    class="form-control"
                                    formControlName="repeat-password"
                                    v-model="repeatPassword"
                                    >
                        </div>
                        <div class="form-group">
                            <label for="hotline-number">{{ getTranslation('lbl_client_hotlineNumber') }}</label>
                            <input
                                    type="text"
                                    id="hotline-number"
                                    class="form-control"
                                    formControlName="hotline-number"
                                    v-model="hotlineNumber"
                                    @keyup="validatePhoneNum($event)"
                            >
                        </div>
                        <!--<div class="form-group">
                            <label>On Duty File</label>
                            <banet-upload :autoUpload="true" fileField="onDutyFile" @setFile="setFile"></banet-upload>
                        </div>-->
                        <div class="form-group">
                            <label for="twilioAccountSid">{{ getTranslation('lbl_client_twilioAccountSid') }}</label>
                            <input
                                    type="text"
                                    id="twilioAccountSid"
                                    class="form-control"
                                    formControlName="twilioAccountSid"
                                    v-model="client.twilioAccountSid">
                        </div>
                        <div class="form-group">
                            <label for="twilioAccountToken">{{getTranslation('lbl_client_twilioAccountToken') }}</label>
                            <input
                                    type="text"
                                    id="twilioAccountToken"
                                    class="form-control"
                                    formControlName="twilioAccountToken"
                                    v-model="client.twilioAccountToken">
                        </div>
                        <div class="form-group">
                            <label for="langSelector">{{ getTranslation('lbl_language') }}</label>
                            <div class="dropdown" v-on-clickaway="dropClose" :class="{ open: isOpened }"
                                 id="langSelector">
                                <button class="dropdown-toggle form-control" @click.prevent="dropToggle" type="button" >
                                    {{ getTranslation(lblLangString) }}
                                    <span class="caret"></span></a>
                                </button>
                                <ul class="dropdown-menu" @click="dropToggle">
                                    <li><a href="#" @click.prevent="setClientLanguage('de');">{{
                                        getTranslation('lbl_deutsch') }}</a></li>
                                    <li><a href="#" @click.prevent="setClientLanguage('en');">{{
                                        getTranslation('lbl_english') }}</a></li>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>{{ getTranslation('lbl_upload_files') }}</label>
                            <banet-upload :autoUpload="true" @setFiles="setFiles" @tempFiles="setTempFiles"></banet-upload>
                        </div>
                        <div class="divider"></div>
                        <button class="btn btn-success" type="submit" >
                            {{ getTranslation('app_lbl_action_client_create') }}
                        </button>
                        <button class="btn pull-right" type="button" @click.prevent="goBack()">
                            {{ getTranslation('app_lbl_action_cancel') }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';
    import {validationMixin} from '../../../../Banet/mixins/validationMixin';

    import BanetUpload from '../upload/Upload.vue';


    //    uploadInstance.listenOnDrop(document.getElementById("dropOnDutyFile"));

    export default {
        mixins: [ translationMixin, dropdownMixin, clickaway, validationMixin ],
        created(){
           this.setClientLanguage('de');
        },
        computed: {
//           getHotlineNum(){
//              this.client.hotlineNumber = this.hotlineNumber;
//              return this.client.hotlineNumber;
//           }
        },
        sockets: {
//            clientChanged: function(){
//                this.$router.push('/clients');
//            },
            clientCreated: function(){
               mainEventBus.$emit('alert', {type: 'success', msg: 'msg_client_created'});
                this.$router.push('/clients');
            },
            clientByUsername: function(client) {
                if (client == null) {
                   this.client.user = this.user;
                   this.$socket.emit('clientCreate', this.client);
                } else {
                   mainEventBus.$emit('alert', {type: 'warning', msg: 'error_username_exists'});
                }
            },
           sameClientExist: function(clientData) {
              let client = clientData.client;
              let user = clientData.user;
              if (client) {
                 if(client.clientName === this.client.clientName){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_client_name_exists' } );
                    return;
                 }
                 if(client.username === this.client.username){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_username_exists' } );
                    return;
                 }
                 if(client.hotlineNumber && client.hotlineNumber === this.client.hotlineNumber){
                     mainEventBus.$emit( 'alert', { type:'warning', msg:'error_hotline_exists' } );
                    return;
                 }
              }
              if (user){
                 if(user.username === this.client.username){
                    mainEventBus.$emit( 'alert', { type:'error', msg:'error_username_exists' } );
                    return;
                 }
                 if(user.email === this.user.email){
                    mainEventBus.$emit( 'alert', { type:'error', msg:'warning_lbl_email_used' } );
                    return;
                 }
              }

             this.client.user = this.user;
             this.$socket.emit('clientCreate', this.client);
           },
        },
        data: function () {
            return {
                client: {},
                user: {},
                lblLangString: '',
                file: '',
                password: '',
                repeatPassword: '',
                required: [
                    { name: 'clientName', found: false },
                    { name: 'firstName', found: false },
                    { name: 'email', found: false },
                   { name: 'username', found: false },
                    { name: 'password', found: false }
                ],
                tempFiles: [],
               language: 'de',
               hotlineNumber: ''
            }
        },
        methods: {
            addClient: function(){
               this.client.hotlineNumber = this.hotlineNumber;
               this.password = this.password.trim();
                if (this.password != '') {
                    if (this.password == this.repeatPassword)
                        this.client.password = this.password;
                    else {
                        mainEventBus.$emit('alert', {type: 'warning', msg: 'error_passwords_no_match'});
                        return false;
                    }
                }
                for (let i in this.client) {
                    if(typeof(this.client[i]) === 'string') {
                        this.client[i] = this.client[i].trim();
                    }
                    for (let j in this.required) {
//                        this.required[j].found = false;
                        if (i === this.required[j].name) {
                            if(this.client[i] !== '') {
                                this.required[j].found = true;
                            }
                        }
                    }
               }
                for (let i in this.user) {
                    if(typeof(this.user[i]) === 'string') {
                        this.user[i] = this.user[i].trim();
                    }
                    for (let j in this.required) {
//                        this.required[j].found = false;
                        if (i === this.required[j].name) {
                            if(this.user[i] !== '') {
                                this.required[j].found = true;
                            }
                        }
                    }
               }
                for (let i in this.required) {
                    if (this.required[i].found == false) {
                        mainEventBus.$emit( 'alert', { type:'warning', msg:'error_' + this.required[i].name + '_required' } );
                       for (let i in this.required) {
                          this.required[i].found = false;
                       }
                        return false;
                    }
                }



                if (this.client.hotlineNumber && this.client.hotlineNumber != '' && !this.checkHotlineNumber()) {
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_wrong_hotline_number_format' } );
                    return false;
                }
                if (this.tempFiles.find(file => file.fileField === '')) {
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_select_file_type' } );
                    return false;
                }


//                this.$socket.emit('getClientByUsername', this.client.username);
               this.$socket.emit('getSameClientExist', null, this.client.clientName, this.client.username,
                  null, this.user.email,this.client.hotlineNumber);
            },
            setFiles: function(files) {
                /*this.client[file.fileField] = file.fileObject;
                console.log(this.client);*/

                for (var i = 0; i < files.length; i++) {
                    if (files[i].fileObject.file) {
                        this.client[files[i].value] = files[i].fileObject.name;

                        if (!this.client.files)
                            this.client.files = {};

                        this.client.files[files[i].value] = files[i].fileObject.file;
                    }
                    else {
                        delete this.client[files[i].value];

                        if (this.client.files) {
                            delete this.client.files[files[i].value];

                            if (Object.keys(this.client.files) == 0)
                                delete this.client.files;
                        }
                    }
                }

                //console.log(this.client);
            },
           setClientLanguage: function(lang){
                this.client.language = lang;
                if(lang == 'en'){
                    this.lblLangString =  this.getTranslation('lbl_english');
                } else if (lang == 'de') {
                    this.lblLangString =  this.getTranslation('lbl_deutsch');
                }
            },
            goBack: function(){
                this.$router.push('/clients');
            },
            checkHotlineNumber: function() {
                var regEx = /^[+-]?\d+$/;
                return regEx.test(this.client.hotlineNumber);
            },
            setTempFiles(tempFiles) {
                this.tempFiles = tempFiles;
            },
            validatePhoneNum(event){
               if(event.key === 'Delete'){
                  this.client.hotlineNumber = this.hotlineNumber;
                  return true;
               }
               this.hotlineNumber = this.validatePhoneChar(this.hotlineNumber);
               this.client.hotlineNumber = this.hotlineNumber;
            }
        },
        components: {
            'banet-upload': BanetUpload
        }
    }
</script>


<style scoped>
    .dropdown {
        width: 100%;
    }
    .dropdown .caret {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .dropdown .dropdown-toggle {
        width: 100%;
        text-align: left;
    }

    .dropdown-menu {
        width: 100%;
        margin-top: -1px;
    }

    /* dropZone */
    .dropZone {
        width: 200px;
        height: 200px;
        background: #ccc;
        border: 2px dashed #333333;
    }

    input.form-control[type="file"] {
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// ClientCreate.vue?e42d3ea8